module.exports = __webpack_public_path__ + "img/bobevo_bobocoin.gm.9968ad4.png";